module.exports = __webpack_public_path__ + "static/media/post_img_2.1a465e21.png";